var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderbgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1880,
    height: 1060,
    viewBox: "0 0 1880 1060",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_29998)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1880,
    height: 1060,
    rx: 20,
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_92_29998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-276 1192.5C-217.167 1020.17 181.1 654.9 399.5 584.5C672.5 496.5 1042.5 476 1339 388C1732.5 271.211 1981.83 -11.3333 2155 -167",
    stroke: "#FF5C00",
    strokeWidth: 115
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_92_29998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-104 1415.5C-45.1667 1243.17 353.1 877.9 571.5 807.5C844.5 719.5 1214.5 699 1511 611C1904.5 494.211 2153.83 211.667 2327 56",
    stroke: "#6F75FF",
    strokeWidth: 115
  })), /*#__PURE__*/React.createElement("line", {
    x1: 62.5347,
    y1: -30,
    x2: 62.5346,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.535,
    y1: -30,
    x2: 165.535,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.535,
    y1: -30,
    x2: 268.535,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.535,
    y1: -30,
    x2: 371.535,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 474.535,
    y1: -30,
    x2: 474.535,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 577.535,
    y1: -30,
    x2: 577.535,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680.535,
    y1: -30,
    x2: 680.535,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 783.535,
    y1: -30,
    x2: 783.535,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 886.535,
    y1: -30,
    x2: 886.535,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 989.535,
    y1: -30,
    x2: 989.535,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1092.53,
    y1: -30,
    x2: 1092.53,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1195.53,
    y1: -30,
    x2: 1195.53,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1298.53,
    y1: -30,
    x2: 1298.53,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1401.53,
    y1: -30,
    x2: 1401.53,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1504.53,
    y1: -30,
    x2: 1504.53,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1607.53,
    y1: -30,
    x2: 1607.53,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1710.53,
    y1: -30,
    x2: 1710.53,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1813.53,
    y1: -30,
    x2: 1813.53,
    y2: 1247,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_92_29998)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -452.966,
    y1: 1027.41,
    x2: 2131.03,
    y2: 1027.41,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: -452.966,
    y1: 924.409,
    x2: 2131.03,
    y2: 924.409,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: -452.966,
    y1: 821.409,
    x2: 2131.03,
    y2: 821.409,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: -452.966,
    y1: 718.409,
    x2: 2131.03,
    y2: 718.409,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: -452.966,
    y1: 615.409,
    x2: 2131.03,
    y2: 615.409,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: -452.966,
    y1: 512.409,
    x2: 2131.03,
    y2: 512.409,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: -452.966,
    y1: 409.409,
    x2: 2131.03,
    y2: 409.409,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: -452.966,
    y1: 306.409,
    x2: 2131.03,
    y2: 306.409,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: -452.966,
    y1: 203.408,
    x2: 2131.03,
    y2: 203.408,
    stroke: "#101010",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: -452.966,
    y1: 100.408,
    x2: 2131.03,
    y2: 100.408,
    stroke: "#101010",
    strokeOpacity: 0.25
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_92_29998",
    x: -630.417,
    y: -509.762,
    width: 3123.86,
    height: 2020.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_92_29998"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_92_29998",
    x: -458.417,
    y: -286.762,
    width: 3123.86,
    height: 2020.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_92_29998"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_29998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1880,
    height: 1060,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_92_29998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1057.91,
    height: 2732.93,
    fill: "white",
    transform: "matrix(0 -1 1 0 -452.966 1027.91)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderbgImage);
export default __webpack_public_path__ + "static/media/HeaderbgImage.ccf5edb6138c6df54dad04f7661c44d4.svg";
export { ForwardRef as ReactComponent };